/* eslint-disable max-len */
import Player from '@vimeo/player';
import utils from '../utils';

// CONSTANTS are all caps.
// eslint-disable-next-line no-unused-vars
const NS = 'VideoBlock';
const CLS = 'videoBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/videoBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class VideoBlock {
	constructor($el) {
		// $el is the widget node return by the loadVideoBlock function
		this.$el = $el;
	}

	init() {
		this.setVideoBlock();
	}

	setVideoBlock() {
		const wg = $(this.$el);
		const videoType = wg.find('.videoBlock-video').data('videoType');
		const videoId = wg.find('.videoBlock-video').data('videoId');
		const video = wg.find('.videoBlock-video');
		const isPrepCls = 'is-preparing';
		const isPlayCls = 'is-playing';
		let vimeoPlayer = null;

		const img = wg.find('.videoBlock-img');
		const imgWidth = img.outerWidth();
		const imgHeight = img.outerHeight();

		video.css({
			width: imgWidth,
			height: imgHeight,
		});

		// Popup video after clicking Play button.
		wg.find('.jumpNextSection').on('click', (e) => {
			// For hiding image and overlay.
			wg.addClass(isPrepCls);

			utils.scrollToEl(wg[0]);

			// Is Vimeo video ?
			// Create a hidden Vimeo Player that will be popup later.
			// @ref https://github.com/vimeo/player.js
			if (this.isVimeoLink(videoType)) {
				video.append('<div data-vimeo-id="' + videoId + '" id="vimeoVideo" />');
				vimeoPlayer = new Player('vimeoVideo');
			}

			// Is Youtube video ?
			// Append an Iframe
			if (this.isYoutubeLink(videoType)) {
				const embedLink = 'https://www.youtube.com/embed/' + videoId;
				video.append('<iframe src="' + embedLink + '" allow="autoplay" />');
			}

			// Is Youku video ?
			// Append an Iframe
			if (this.isYoukuLink(videoType)) {
				const embedLink = 'https://player.youku.com/embed/' + videoId;
                video.append('<iframe src="' + embedLink + '" allow="autoplay" />');
			}

			// Start Vimeo video.
			if (videoType === 'vimeo') vimeoPlayer.play();

			// Start Youtube video.
			if (videoType === 'youtube') {
				const src = $('iframe', video).attr('src');
				$('iframe', video).attr('src', src + '?autoplay=1&rel=0');
			}

			// Start Youku video.
			if (videoType === 'youku') {
				const src = $('iframe', video).attr('src');
				$('iframe', video).attr('src', src + '?autoplay=1&rel=0&showinfo=0');
			}

			const wgWidth = wg.outerWidth();
			const videoWidth = wgWidth;
			const videoHeight = wgWidth / 16 * 9; // Video ratio is 16:9

			// prevent video jumping
			wg.find(WG + 'img').css('height', videoHeight);
			video.show().animate({
				width: videoWidth,
				height: videoHeight,
			}, 1000, 'linear');
			setTimeout(() => {
				wg.removeClass(isPrepCls);
				wg.addClass(isPlayCls);
			}, 1000);
		});
	}

	isVimeoLink(videoType) {
		return videoType === 'vimeo';
	}

	isYoutubeLink(videoType) {
		return videoType === 'youtube';
	}

	isYoukuLink(videoType) {
		return videoType === 'youku';
	}
}
